import { fieldAddProductVulcan } from '../../../utils/constant';
import { getFieldValue } from '../../utils';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

/**
 * Eastern provinces that have limited product visibility.
 * Users in these provinces see only Business WiFi and TELUS Secure Business.
 * Province names must match EN.json values exactly (case-sensitive).
 */
const EASTERN_PROVINCES = [
  'New Brunswick',
  'Nova Scotia',
  'Prince Edward Island',
  'Newfoundland and Labrador'
];

/**
 * Filter products based on province visibility rules.
 * For Eastern provinces: show only Business WiFi and TELUS Secure Business
 * For other provinces: show all products (no province-based filtering)
 */
export const filterProductsByProvince = (province, products, locale) => {
  if (!province || !Array.isArray(products)) {
    return products;
  }

  const vulcanWebform =
    locale === 'en-US' ? EN.vulcanWebform : FR.vulcanWebform;

  if (EASTERN_PROVINCES.includes(province)) {
    const allowedProducts = [
      vulcanWebform.vulBusinessWifi,
      vulcanWebform.vulTSB
    ];
    return products.filter(product =>
      allowedProducts.includes(product.fields.value)
    );
  }

  return products;
};

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

export const handleVulcanProductDisable = ({
  formFields,
  businessWifiVul,
  vulFibreInternet,
  vulBusinessWifi,
  orderData
}) => {
  const existingVulcanProduct = getFieldValue('productVulcan', formFields);
  let isProductDisable = false;

  if (existingVulcanProduct) {
    isProductDisable = existingVulcanProduct.includes(businessWifiVul);
  }

  if (orderData.isThisVulcanOrder) {
    disableOptions(
      formFields[fieldAddProductVulcan].options,
      [vulFibreInternet, vulBusinessWifi],
      true
    );
    if (isProductDisable) {
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [vulBusinessWifi],
        false
      );
    }
  } else {
    disableOptions(
      formFields[fieldAddProductVulcan].options,
      [vulFibreInternet, vulBusinessWifi],
      false
    );
  }
};

/**
 * TELUS Internet Backup is visible to all outlets and channels.
 * @param {string} outletCode - The sales rep outlet code (unused; kept for API compatibility)
 * @returns {boolean} - Always true
 */
export const isOutletAllowedForTelusInternetBackup = () => {
  return true;
};
